<template>
    <div class="page-content ">
    <div class="our-business mb-60">
        <div class="own-title margin-bottom-20">
            Our Culture
        </div>
        <div class="ipad-display">
            <carousel :autoplay="false" :nav="true" :items="1" :margin="20" :dots="false" :stagePadding="15" :navText="['<', '>']">
                <SliderIntroWithBg
                    bgImage="our_culture/iPad/01.png"
                    bgImageDesk="our_culture/iPad/01.png"
                    textImage="our_culture/iPad/01-text.png"
                    textImageDesk="our_culture/iPad/01-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="our_culture/iPad/02.png"
                    bgImageDesk="our_culture/iPad/02.png"
                    textImage="our_culture/iPad/02-text.png"
                    textImageDesk="our_culture/iPad/02-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="our_culture/iPad/03.png"
                    bgImageDesk="our_culture/iPad/03.png"
                    textImage="our_culture/iPad/03-text.png"
                    textImageDesk="our_culture/iPad/03-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
            </carousel>
        </div>
        <div class="mobile-display">
            <carousel :autoplay="false" :nav="true" :items="1" :margin="20" :dots="false" :stagePadding="15" :navText="['<', '>']">
                <SliderIntroWithBg
                    bgImage="our_culture/01.png"
                    bgImageDesk="our_culture/01.png"
                    textImage="our_culture/01-text.png"
                    textImageDesk="our_culture/01-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="our_culture/02.png"
                    bgImageDesk="our_culture/02.png"
                    textImage="our_culture/02-text.png"
                    textImageDesk="our_culture/02-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="our_culture/03.png"
                    bgImageDesk="our_culture/03.png"
                    textImage="our_culture/03-text.png"
                    textImageDesk="our_culture/03-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
            </carousel>
        </div>
            <div class="nav-link">
            <NavLink index="2" />
            </div>
    </div>
    </div>
</template>
<style scoped>
    .own-bg {
        background : #1F1F1F;
    }
    .pt-10 {
        padding-top: 10px;
    }
    .mt-10 {
        margin-top: 10px;
    }
    .mb-10 {
        margin-bottom: 10px;
    }
    .mb-60 {
        margin-bottom: 60px;
    }
    .line-30 {
        line-height: 30px;
    }
    .img-height {
        max-height: 500px;
        height: auto;
        max-width: 100%;
        border-radius: 15px !important;
    }
    .d-block {
        display: block;
    }
    .ovr-caption-mb-10 {
        margin-bottom: 10px !important;
    }
    .ovr-caption-mb-20 {
        margin-bottom: 20px !important;
    }
    @media (max-width: 320px){
        .xs-container-height{
            height: 450px !important;
        }
    }
</style>
<script>
import NavLink from '@/components/NavLink.vue'
import carousel from 'vue-owl-carousel'
import SliderIntroWithBg from '@/components/SliderIntroWithBg.vue'

export default {
    name: 'Our_business',
    components: {
        NavLink, carousel, SliderIntroWithBg
    },
    mounted() {
        var owl = document.querySelector('.nav-link .owl-stage');
        var width=owl.style.width;
        var each=parseFloat(width);
        owl.style.transform='translate3d(-'+(each/2-15)+'px, 0px, 0px)';
    }
}
</script>
